exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".magidei-shiur-list input#magidei-filter {\n  border-radius: 10px 0 0 10px;\n  height: 40px;\n  border-right: none;\n}\n.magidei-shiur-list .input-group-text {\n  border-radius: 0 10px 10px 0;\n  background: transparent;\n  border-left: none;\n}\n.magidei-shiur-list .input-group-text .fa {\n  color: #ccc;\n  font-weight: bold;\n  font-size: 1rem;\n}", ""]);

// exports
exports.locals = {
	"primary": "#aa4121",
	"secondary": "#ccc",
	"gray": "#636363"
};